<template>
  <div id="app">
    <MyTimer />
  </div>
</template>

<script>
import MyTimer from './components/MyTimer.vue';

export default {
  name: 'App',
  components: {
    MyTimer
  }
};
</script>

<style>
#app {
  font-family: 'M PLUS Rounded 1c', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #9B92C3;
}
body {
  touch-action: none;
  -ms-touch-action: none; /* for IE/Edge */
}
html, body, #app {
  overflow: hidden;
  height: 100%;
  margin: 0;
}
</style>
